import { FaRobot, FaSearch, FaBook } from 'react-icons/fa';

export const projectsData = [
  {
    title: 'Wealingo - Your AI powered language tutor',
    description: 'Language learning demo showcased at re:invent 2024 - adaptive learning with Hybrid search and RAG ',
    technologies: ['React', 'Weaviate', 'Embeddings', 'Django'],
    category: 'demo',
    icon: <FaSearch />,
    github: 'https://github.com/dee-at-weaviate/django_wealingo',
    demo: '#', // Add your demo URL here
    article: 'https://weaviate.io/blog/wealingo-demo',
  },
  {
    title: 'AWS SageMaker RAG Workshop',
    description: 'Comprehensive guide for building RAG applications with AWS SageMaker Studio, demonstrating enterprise-grade AI implementation.',
    technologies: ['Python', 'AWS SageMaker Unified Studio', 'Weaviate', 'RAG'],
    category: 'workshop',
    icon: <FaBook />,
    github: 'https://github.com/dee-at-weaviate/sagemaker-studio-weaviate',
    article: 'https://weaviate.io/blog/sagemaker-studio-rag',
  },
  // {
  //   title: 'Model Evaluation & Guardrails',
  //   description: 'Enterprise workflow implementation showcasing model evaluation techniques and production guardrails for AI systems.',
  //   technologies: ['Python', 'GenAI', 'Evaluation Metrics', 'Safety'],
  //   category: 'enterprise',
  //   icon: <FaChartLine />,
  //   article: 'https://weaviate.io/blog/when-good-models-go-bad',
  // },

  {
    title: 'Agentic Enterprise Workflows',
    description: 'Production-ready patterns (+ code samples) for building agentic enterprise workflows with vector databases.',
    technologies: ['Python', 'LangChain', 'Weaviate', 'RAG', 'ArizeAI', 'Weights&Biases', 'Hybrid search', 'Bedrock'],
    category: 'tutorial',
    icon: <FaRobot />,
    github: 'https://github.com/dee-at-weaviate/evals-and-guardrails',
    article: 'https://2025-11-05-evals-and-guardrails-p--tangerine-buttercream-20c32f.netlify.app/blog/evals-enterprise-workflows-3',
  },
  // {
  //   title: 'RAG Evaluation Framework',
  //   description: 'Comprehensive framework for evaluating RAG systems with metrics for retrieval quality and generation accuracy.',
  //   technologies: ['Python', 'RAG', 'Evaluation', 'ML Ops'],
  //   category: 'enterprise',
  //   icon: <FaChartLine />,
  //   github: 'https://github.com/dee-at-weaviate',
  //   article: 'https://weaviate.io/blog/evals-guardrails-enterprise-workflows-2',
  // },
  // {
  //   title: 'Getting Started with Embeddings',
  //   description: 'Beginner-friendly tutorial on understanding and implementing embeddings for semantic search applications.',
  //   technologies: ['Python', 'Embeddings', 'Vector Search', 'Tutorial'],
  //   category: 'tutorial',
  //   icon: <FaBook />,
  //   github: 'https://github.com/dee-at-weaviate',
  // },
];

// To add a new project, simply add a new object to the array above with the following structure:
/*
{
  title: 'Project Title',
  description: 'Brief description of the project',
  technologies: ['Tech1', 'Tech2', 'Tech3'],
  category: 'demo' | 'tutorial' | 'enterprise',
  icon: <IconComponent />, // Optional, defaults to FaCode
  github: 'https://github.com/your-repo', // Optional
  demo: 'https://your-demo-url', // Optional
  article: 'https://your-article-url', // Optional
}
*/

